<div
  [ngClass]="
    'widget__item clickable ' +
    (isFetching ? 'widget__item--loading ' : '') +
    (classList | addClassList: { mainClass: 'widget__item--' }) +
    (selectedDatesLabel !== '' ? ' widget__item--has-content' : '') +
    (readOnly && !isFetching ? ' widget__item--readonly' : '')
  "
  [attr.id]="'qa_datepicker-' + classList"
>
  <div class="widget__item-picker-wrap" (click)="showHideCalendar($event)">
    <span
      [ngClass]="
        'widget__element-label ' +
        (classList | addClassList: { mainClass: 'widget__element-label--' }) +
        (selectedDates && selectedDates.length && selectedDatesLabel !== ' - '
          ? ' widget__element-label--notEmpty'
          : '')
      "
    >
      {{ 'booking-widget-date' | translate }}
    </span>
    <span
      id="qa_open-datepicker-overlay"
      [ngClass]="
        'widget__single-line ' +
        (classList | addClassList: { mainClass: 'widget__single-line--' }) +
        (selectedDates && selectedDates.length && selectedDatesLabel !== ' - ' ? '' : '') +
        (selectedDates && selectedDates.length && selectedDatesLabel !== ' - ' ? '' : ' widget__single-line--empty')
      "
    >
      <ng-container *ngIf="selectedDates && selectedDates.length && selectedDatesLabel !== ' - '">
        <span class="widget__single-line-from">
          {{ selectedDates[0] | formatDate: 'MMM dd' : currentLang | titlecase }}
        </span>
        <span class="widget__single-line-dash">-</span>
        <span class="widget__single-line-to">
          {{ selectedDates[1] | formatDate: 'MMM dd' : currentLang | titlecase }}
        </span>
      </ng-container>
      <span class="widget__element-icon {{ classList | addClassList: { mainClass: 'widget__element-icon--' } }}">
        <ng-container *ngTemplateOutlet="limehomeCalendarSvg" />
      </span>
    </span>
  </div>
</div>

<ng-template #limehomeCalendarSvg>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_30908_15703)">
      <path
        d="M10.1355 4.09375V5.5H15.198V4.09375C15.198 3.63672 15.5496 3.25 16.0417 3.25C16.4988 3.25 16.8855 3.63672 16.8855 4.09375V5.5H18.2917C19.5222 5.5 20.5417 6.51953 20.5417 7.75V8.3125V10V19C20.5417 20.2656 19.5222 21.25 18.2917 21.25H7.04175C5.77612 21.25 4.79175 20.2656 4.79175 19V10V8.3125V7.75C4.79175 6.51953 5.77612 5.5 7.04175 5.5H8.448V4.09375C8.448 3.63672 8.79956 3.25 9.29175 3.25C9.74878 3.25 10.1355 3.63672 10.1355 4.09375ZM6.47925 10V19C6.47925 19.3164 6.72534 19.5625 7.04175 19.5625H18.2917C18.573 19.5625 18.8542 19.3164 18.8542 19V10H6.47925ZM12.6667 11.4062C13.1238 11.4062 13.5105 11.793 13.5105 12.25V13.9375H15.198C15.655 13.9375 16.0417 14.3242 16.0417 14.7812C16.0417 15.2734 15.655 15.625 15.198 15.625H13.5105V17.3125C13.5105 17.8047 13.1238 18.1562 12.6667 18.1562C12.1746 18.1562 11.823 17.8047 11.823 17.3125V15.625H10.1355C9.64331 15.625 9.29175 15.2734 9.29175 14.7812C9.29175 14.3242 9.64331 13.9375 10.1355 13.9375H11.823V12.25C11.823 11.793 12.1746 11.4062 12.6667 11.4062Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_30908_15703">
        <rect width="24" height="24" fill="white" transform="translate(0.666748)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
